module.exports = __webpack_public_path__ + "img/pic_11.551757ae.jpg";